import { Injectable } from "@angular/core";
import { TaskHttpService } from "./task-http.service";
import { Observable, forkJoin, map, of } from "rxjs";
import { ITask } from "./task.interface";
import * as _ from 'lodash';
import { ITaskComment, ITaskCommentFilter } from "./task-comment/task-comment.interface";
import { TaskCommentService } from "./task-comment/task-comment.service";
import { AuthService } from "../../../shared/services/auth.service";
import { BillingDocumentService } from "../../billing-documents-page/billing-documents/billing-documents.service";
import { ITimeTrack, ITimeTrackFilter } from "../../time-tracks-page/time-track/time-track.interface";
import { TimeTrackService } from "../../time-tracks-page/time-track/time-track.service";
import { IAppointment } from "./appoinment/appointment.interface";
import { AppointmentsService } from "./appoinment/appointment.service";

@Injectable()
export class TaskService {
  filterTimeTrack!: ITimeTrackFilter;
  filterComments!:  ITaskCommentFilter;
  public http: TaskHttpService;

  constructor( 
    private _AuthService: AuthService,
    private _TaskHttpService: TaskHttpService,
    private _BillingDocumentService: BillingDocumentService,
    private _TimeTrackService: TimeTrackService,
    private _AppointmentsService: AppointmentsService,
    private _TaskCommentService: TaskCommentService,
  ) {
    this.http = this._TaskHttpService;

    this.filterTimeTrack = {
      company: this._AuthService.companyId(),
      skip: 0,
      limit: 10000,
      filters: {}
    };
    this.filterComments = {
      company: this._AuthService.companyId(),
    };
  }

  getBillingDocument(task: any): Observable<ITask> {
    return !task ? of(undefined) : this._BillingDocumentService.getBillingDocumentByTask(task);
  }

  getTimeTracks(task: any): Observable<ITimeTrack[] | undefined> {
    if (!task) {
      return of(undefined);
    }

    this.filterTimeTrack.task = task._id;

    const observables = task.workers.map((worker: any) => {
      this.filterTimeTrack.worker = worker._id;
      let workerName = worker?.firstname + " " + worker?.lastname;

      return this._TimeTrackService.getTimeTracksGroupByTask(this.filterTimeTrack).pipe(
        map((timeTracks: any[]) => {
          if (timeTracks && timeTracks.length > 0) {
            timeTracks[0].workerName = workerName;
            timeTracks[0].formatTotalworked = this.formatTime(timeTracks[0].totalrealworked);
            timeTracks[0].formatTotalbreak = this.formatTime(timeTracks[0].totalbreak);
          }
          return timeTracks;
        })
      );
    });

    return forkJoin(observables).pipe(
      map((results: any) => _.uniqBy(_.flatten(results), '_id'))
    );
  }

  getTimeTracks2(task: { _id: string | undefined; workers: any[]; }): any {
    let tt: any;
    this.filterTimeTrack.task = task._id;

    task.workers.forEach(worker => {
      this.filterTimeTrack.worker = worker._id;
      let workerName = worker?.firstname + " " + worker?.lastname;

      this._TimeTrackService.getTimeTracksGroupByTask(this.filterTimeTrack).subscribe((timeTracks: any[]) => {
        if (timeTracks !== undefined && timeTracks.length > 0) {
          timeTracks[0].workerName = workerName;
          timeTracks[0].formatTotalworked = this.formatTime(timeTracks[0].totalrealworked);
          timeTracks[0].formatTotalbreak = this.formatTime(timeTracks[0].totalbreak);
        }
        tt = _.uniqBy(_.concat(tt, timeTracks), '_id');
      });
    });


    return !task ? of(undefined) : tt;
  }

  getAppointments(id: string | IAppointment | undefined): Observable<IAppointment>{
    return !id ? of(undefined) : this._AppointmentsService.getAppointment(id)
  }

  getComments(id: string | undefined): Observable<ITaskComment[]>{
    this.filterComments.task = id;
    return !id ? of(undefined) : this._TaskCommentService.getComments(this.filterComments)
  }

  formatTime(milliseconds: number): string {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    let formattedTime = '';
    if (hours > 0) {
      formattedTime += `${hours}h `;
    }
    if (minutes > 0) {
      formattedTime += `${minutes}m `;
    }
    if (seconds > 0) {
      formattedTime += `${seconds}s`;
    }
    formattedTime = formattedTime.trim();
    return formattedTime;
  }

}